const filterFalsy = <T>(array?: (T | null | undefined | 0 | false)[]): T[] =>
  (array?.filter(element => !!element) || []) as T[]

export default filterFalsy
